import 'angular';
import * as _ from 'lodash-es';
import Features from '../feature-manager/Features';
import AppConstants from '../gorillaboy/AppConstants';
import {NewTaskControllerScope, GetTasksResponse, Task, Action} from '../types/TaskTypes';
import TasksService from './TasksService';
import './new_task_dialog.html';


function NewTaskController($scope: NewTaskControllerScope, TasksService: TasksService,
         authenticatedUser: any,
         $log: ng.ILogService,
         $translate: ng.translate.ITranslateService,
         MessageManager: any,
         SignalProvider: any,
         DateTimeService: any) {

     const userInfo = authenticatedUser.getUserInfo();

     $scope.formData = {};

     $scope.createTaskBtnClicked = function() {
         TasksService.createTask($scope.formData.title, $scope.formData.description, null, AppConstants.TASKDEF_IDS.TODO_TASK)
         .then($scope.$close.bind($scope), (response) => {
             $log.error("Error occured while creating a task");
             MessageManager.addErrorMessage($translate.instant('TASKS.CREATE_TASK_MODAL.ERROR_MESSAGES.CREATE_FAILED'));
         });
     };
}

NewTaskController.$inject = ['$scope',
    'TasksService',
    'authenticatedUser',
    '$log',
    '$translate',
    'MessageManager',
    'SignalProvider',
    'DateTimeService'];

angular.module('GorillaBoy.Tasks')
.controller('NewTaskController', NewTaskController);
